var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import EventEmitter from 'events';
import { logger } from './logger';
export var TrackType;
(function (TrackType) {
    TrackType["Camera"] = "camera";
    TrackType["Microphone"] = "microphone";
    TrackType["Screen"] = "screen";
    TrackType["ScreenAudio"] = "screen-audio";
})(TrackType || (TrackType = {}));
export var MediaState;
(function (MediaState) {
    MediaState["Connecting"] = "connecting";
    MediaState["Connected"] = "connected";
    MediaState["Reconnecting"] = "reconnecting";
    MediaState["Disconnected"] = "disconnected";
})(MediaState || (MediaState = {}));
var MediaProvider = /** @class */ (function (_super) {
    __extends(MediaProvider, _super);
    function MediaProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._mediaState = MediaState.Disconnected;
        _this.connect = function (accessToken, localTracks) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._mediaState = MediaState.Connecting;
                        this.emit('connecting');
                        return [4 /*yield*/, this.connectToRoom(accessToken, localTracks)];
                    case 1:
                        _a.sent();
                        this._mediaState = MediaState.Connected;
                        this.emit('connected');
                        return [2 /*return*/];
                }
            });
        }); };
        _this.disconnect = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._mediaState === MediaState.Disconnected) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.disconnectFromRoom()];
                    case 1:
                        _a.sent();
                        this._mediaState = MediaState.Disconnected;
                        this.emit('disconnected');
                        return [2 /*return*/];
                }
            });
        }); };
        /** Room state management */
        _this.onDisconnect = function () {
            _this._mediaState = MediaState.Disconnected;
            _this.emit('disconnected');
        };
        _this.onReconnecting = function () {
            _this._mediaState = MediaState.Reconnecting;
            _this.emit('reconnecting');
        };
        _this.onReconnect = function () {
            _this._mediaState = MediaState.Connected;
            _this.emit('connected');
        };
        _this.onTrackSubscribed = function (participantSid, trackType) {
            var participantId = _this.getParticipantIdFromSid(participantSid);
            if (!participantId) {
                _this.emit('warning', new Error('Track published from unrecognized participant ' +
                    participantSid +
                    ', cannot start track'));
                return;
            }
            _this.emit('remoteTrackStarted', participantId, trackType);
            _this.emit('trackStarted', participantId, trackType);
        };
        _this.onTrackUnsubscribed = function (participantSid, trackType) {
            var participantId = _this.getParticipantIdFromSid(participantSid);
            if (!participantId) {
                _this.emit('warning', new Error('Track unpublished from unrecognized participant ' +
                    participantSid +
                    ', cannot stop track'));
                return;
            }
            _this.emit('remoteTrackStopped', participantId, trackType);
            _this.emit('trackStopped', participantId, trackType);
        };
        _this.onLocalTrackPublished = function (trackType) {
            var localSid = _this.getLocalParticipantSid();
            var localId = localSid && _this.getParticipantIdFromSid(localSid);
            if (localId) {
                _this.emit('trackStarted', localId, trackType);
            }
        };
        _this.onLocalTrackUnpublished = function (trackType) {
            var localSid = _this.getLocalParticipantSid();
            var localId = localSid && _this.getParticipantIdFromSid(localSid);
            if (localId) {
                _this.emit('trackStopped', localId, trackType);
            }
        };
        /** Participant management */
        _this._participantSidAssociationMap = new Map();
        /**
         * You must call this method when a new participant joins to associate
         * their internal media provider ID (such as a Twilio SID) with the
         * external app ID for the participant according to the consumer.
         */
        _this.associateParticipantWithId = function (participantSid, participantId) {
            _this._participantSidAssociationMap.set(participantId, participantSid);
            _this._participantSidToIdCache.set(participantSid, participantId);
        };
        _this.getParticipantSidFromId = function (participantId) {
            var _a;
            return (_a = _this._participantSidAssociationMap.get(participantId)) !== null && _a !== void 0 ? _a : null;
        };
        _this.getParticipantIds = function () {
            return Array.from(_this._participantSidAssociationMap.keys());
        };
        _this.onParticipantConnected = function (participantSid, participantId) {
            _this.associateParticipantWithId(participantSid, participantId);
            _this.emit('participantConnected', participantId);
        };
        _this.onParticipantDisconnected = function (participantSid) {
            var participantId = _this._participantSidToIdCache.get(participantSid);
            if (participantId) {
                _this._participantSidAssociationMap.delete(participantId);
                _this._participantSidToIdCache.delete(participantSid);
                _this.emit('participantDisconnected', participantId);
            }
            else {
                _this.emit('warning', new Error('Unrecognized participant disconnected ' + participantSid));
            }
        };
        /**
         * This cache is necessary specifically for disconnects.
         * We can't rely on the implemented provider to still 'remember' a
         * participant after they disconnect, but we still need to lookup their
         * ID. So we cache the reverse lookup of SID->ID, then evict once
         * they're disconnected.
         */
        _this._participantSidToIdCache = new Map();
        /**
         * Messages
         */
        _this.broadcastMessage = function (message) {
            _this.sendMessage(message);
        };
        _this.onMessage = function (sourceParticipantSid, message) {
            var participantId = _this.getParticipantIdFromSid(sourceParticipantSid);
            if (!participantId) {
                _this.emit('warning', new Error('Message received from unrecognized participant ' +
                    sourceParticipantSid +
                    ', cannot process message'));
                return;
            }
            _this.emit('message', participantId, message);
        };
        return _this;
    }
    Object.defineProperty(MediaProvider.prototype, "mediaState", {
        get: function () {
            return this._mediaState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaProvider.prototype, "localParticipantId", {
        get: function () {
            var sid = this.getLocalParticipantSid();
            if (!sid)
                return null;
            return this.getParticipantIdFromSid(sid);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starting and stopping local media devices
     */
    MediaProvider.prototype.startMediaInternal = function (trackType, track) {
        return __awaiter(this, void 0, void 0, function () {
            var localParticipantSid, participantId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localParticipantSid = this.getLocalParticipantSid();
                        if (!localParticipantSid)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.publishLocalMedia(trackType, track)];
                    case 1:
                        _a.sent();
                        participantId = this.localParticipantId;
                        if (!participantId) {
                            // local participant SID has not been assigned yet
                            logger.debug("[MediaProvider] media started but local participant SID not yet assigned");
                            return [2 /*return*/];
                        }
                        this.emit('trackStarted', participantId, trackType);
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaProvider.prototype.stopMediaInternal = function (trackType) {
        return __awaiter(this, void 0, void 0, function () {
            var localParticipantSid, trackSid, participantId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localParticipantSid = this.getLocalParticipantSid();
                        if (!localParticipantSid)
                            return [2 /*return*/];
                        trackSid = this.getParticipantTrackSidByType(localParticipantSid, trackType);
                        if (!trackSid) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.unpublishLocalMedia(trackSid, trackType)];
                    case 1:
                        _a.sent();
                        participantId = this.localParticipantId;
                        if (!participantId) {
                            // local participant SID has not been assigned yet
                            return [2 /*return*/];
                        }
                        this.emit('trackStopped', participantId, trackType);
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaProvider.prototype.getParticipantTrack = function (participantId, trackType) {
        // map participant ID to media ID
        var participantSid = this.getParticipantSidFromId(participantId);
        if (!participantSid) {
            return null;
        }
        // find the track by type
        var trackSid = this.getParticipantTrackSidByType(participantSid, trackType);
        if (!trackSid) {
            return null;
        }
        var track = this.getMediaStreamTrack(participantSid, trackSid);
        return track;
    };
    // you can override this to provide a more efficient access method!
    MediaProvider.prototype.getParticipantTrackSidByType = function (participantSid, trackType) {
        var _this = this;
        var trackSids = this.getParticipantTrackSids(participantSid);
        var trackSid = trackSids.find(function (sid) { return _this.getTrackTypeFromTrackSid(participantSid, sid) === trackType; });
        if (!trackSid) {
            return null;
        }
        return trackSid;
    };
    return MediaProvider;
}(EventEmitter));
export { MediaProvider };
//# sourceMappingURL=MediaProvider.js.map